import PhoneSmsIcon from 'Assets/images/commons/phone-sms-icon.svg';
import PhoneCallIcon from 'Assets/images/commons/phone-call-icon.svg';
import EmailIcon from 'Assets/images/commons/email-icon.svg';
import React from 'react';

export const OtpMethod = {
  SMS: 0,
  CALL: 1,
  EMAIL: 2,
};

export const getOtpMethodName = (otpMethod: number) => {
  switch (otpMethod) {
    case OtpMethod.SMS:
      return 'Phone SMS';
    case OtpMethod.CALL:
      return 'Phone Call';
    case OtpMethod.EMAIL:
      return 'Email';
    default:
      return '';
  }
};

export const otpMethodOptions = [
  {
    text: getOtpMethodName(OtpMethod.SMS),
    icon: <img src={PhoneSmsIcon} alt="sms" />,
    value: OtpMethod.SMS,
  },
  {
    text: getOtpMethodName(OtpMethod.CALL),
    icon: <img src={PhoneCallIcon} alt="call" />,
    value: OtpMethod.CALL,
  },
  {
    text: getOtpMethodName(OtpMethod.EMAIL),
    icon: <img src={EmailIcon} alt="email" />,
    value: OtpMethod.EMAIL,
  },
];
